export default __webpack_public_path__ + "static/backstage-screenshot-512x438-bca2827790e7c83df5d87a357994f028.webp";